import img1 from '../images/img-collection/collection-7.jpg'
import img2 from '../images/img-collection/collection-8.jpg'
import img3 from '../images/img-collection/collection-9.jpg'
import img4 from '../images/img-collection/collection-10.jpg'
import img5 from '../images/img-collection/collection-11.jpg'
import img6 from '../images/img-collection/collection-12.jpg'
import img7 from '../images/img-collection/collection-13.jpg'
import avt1 from '../images/avatar/avt-15.jpg'
import avt2 from '../images/avatar/avt-16.jpg'
import avt3 from '../images/avatar/avt-17.jpg'
import avt4 from '../images/avatar/avt-18.jpg'
import avt5 from '../images/avatar/avt-19.jpg'
import avt6 from '../images/avatar/avt-20.jpg'
import avt7 from '../images/avatar/avt-21.jpg'
import avt8 from '../images/avatar/avt-22.jpg'

const dataHotCollection2 = [
    {
        img: img1,
        avt: avt1,
        name: 'John S. Outenewes',
        position: 'ERC-75',
        active: 'active'
    },
    {
        img: img2,
        avt: avt2,
        name: 'Michel Doknia Kalia',
        position: 'ERC-75'
    },
    {
        img: img3,
        avt: avt3,
        name: 'Somalia X Silva',
        position: 'ERC-75'
    },
    {
        img: img4,
        avt: avt4,
        name: 'Medas S Alskae',
        position: 'ERC-75'
    },
    {
        img: img2,
        avt: avt5,
        name: 'David Mich Hussy',
        position: 'ERC-75'
    },
    {
        img: img5,
        avt: avt6,
        name: 'John S. Outenewes',
        position: 'ERC-75'
    },
    {
        img: img6,
        avt: avt7,
        name: 'Zavi HD. Xossy',
        position: 'ERC-75'
    },
    {
        img: img7,
        avt: avt8,
        name: 'Fillips H Hearts',
        position: 'ERC-75'
    },
    {
        img: img2,
        avt: avt5,
        name: 'David Mich Hussy',
        position: 'ERC-75'
    },
    {
        img: img5,
        avt: avt6,
        name: 'John S. Outenewes',
        position: 'ERC-75'
    },
    {
        img: img6,
        avt: avt7,
        name: 'Zavi HD. Xossy',
        position: 'ERC-75'
    },
    {
        img: img7,
        avt: avt8,
        name: 'Fillips H Hearts',
        position: 'ERC-75'
    },
    

]

export default dataHotCollection2;